export default {
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyCHo-Wjch9hc0McjT8jBTsY9ouX_EE0980',
    authDomain: 'v3.scaffoldhub.io',
    databaseURL: 'https://scaffoldhub.firebaseio.com',
    projectId: 'project-3653376377848283500',
    storageBucket:
      'project-3653376377848283500.appspot.com',
    messagingSenderId: '512588433990',
    appId: '1:512588433990:web:6069e5cff70d4de9',
  },
  CLIENT_WEB_URL: 'https://scaffoldhub.io',
  CLIENT_APP_URL: 'https://v3.scaffoldhub.io',
  SERVER_URL: 'https://scaffoldhub-backend.web.app',
  GOOGLE_ANALYTICS_KEY: 'UA-78491278-1',
  GOOGLE_ERROR_API:
    'AIzaSyDLhp8X5ZBgTE9MZ7MJs58rFGyCxNodr_8',
  GOOGLE_PROJECT_ID: 'scaffoldhub',
  DEBUG_BUILDER: false,
  BASE_URL: '/',
  PREVIEW_URL_ENABLED: true,
  PREVIEW_URL_POOLING_INTERNVAL_IN_MILLIS: 10000,
  PAYPAL_CODES: {
    USD: 'D9Y8H3XVKHK5W',
    BRL: 'PJRU8MNUGY2JY',
  },
  PAYPAL_URL: 'https://www.paypal.com',
  STRIPE_TOKEN:
    'pk_live_WeiAGjNV2oo1SW5a02KebffR00rslsLLqJ',
  STRIPE_SKU: 'sku_OpxkRaggxKVgJH',
};
